module.exports = __webpack_public_path__ + "static/media/clock.4180ac21.svg";